import type { IconProps } from '../types/IconProps.ts';
export const Clapperboard: IconProps = {
    name: 'Clapperboard',
    children: [
        `<path d="M3 11v8c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-8M3 11h18M3 11l17-5M7 6l3 3M12.5 4.5 15 7M3 11l-.53-2.14a2 2 0 0 1 1.37-2.4L17 2.59a2 2 0 0 1 2.5 1.43L20 6" />`,
    ]
};